/**
 * OpenCalendarQuickAction
 * -----------------------------------------------------------------------------
 * Atalho do FAB do chat que abre o Calendário em um modal (mesma tela de
 * /tenant/calendar), sem tirar o usuário da conversa.
 *
 * @version 2.0.0
 * RELEASE: 2026-08-06 v2.0.0 - Abre CalendarModal ao invés de navegar para a página
 * RELEASE: 2026-06-25 v1.0.0 - Criação do atalho "Calendário" no FAB do chat.
 */

import { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { CalendarModal } from '@/components/calendar/CalendarModal';

export function OpenCalendarQuickAction() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={() => setOpen(true)}
              aria-label="Calendário"
              className="h-11 w-11 rounded-full flex items-center justify-center text-foreground hover:text-primary transition-colors"
            >
              <CalendarDays className="h-5 w-5" />
            </button>
          </TooltipTrigger>
          <TooltipContent side="right">Calendário</TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {/* Modal com o calendário completo (mesmas permissões da página) */}
      <CalendarModal open={open} onOpenChange={setOpen} />
    </>
  );
}
